import React from 'react';
import { MessageCircle } from 'lucide-react';

export default function CommunityBoxes({ boxes = [], title = 'Topluluk' }) {
  if (!Array.isArray(boxes) || boxes.length === 0) {
    return null;
  }

  return (
    <section className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-6">
      <div className="mb-5">
        <h3 className="text-xl font-black text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
          {title}
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {boxes.map((item, index) => (
          <button
            key={`${item?.title || 'community'}-${index}`}
            type="button"
            onClick={() => item?.whatsapp_url && window.open(item.whatsapp_url, '_blank')}
            className="text-left rounded-2xl border border-emerald-500/15 bg-[#0C1827] px-5 py-4 hover:border-emerald-400/40 transition-colors"
          >
            <div className="flex items-center gap-4">
              <div className="h-12 w-12 rounded-full bg-emerald-500 flex items-center justify-center text-white">
                <MessageCircle className="w-6 h-6" />
              </div>
              <div>
                <p className="text-lg font-semibold text-white">{item?.title || 'Topluluk'}</p>
                <p className="text-sm text-[#94A3B8]">{item?.description || ''}</p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
